import i18n from '@/components/i18n'
import { getRegionContext } from '@/api/common'
import { DEFAULT_REGION_CONTEXT, normalizeRegionContext, REGION_UNKNOWN } from '@/utils/region-context'
import { resolveGeoIpContext } from '@/utils/geoip'
import { DEFAULT_LOCALE, forceLocaleFromIP, resolvePreferredLocale } from '@/utils/locale-preference'

const region = {
  state: {
    region: DEFAULT_REGION_CONTEXT.region,
    regionName: DEFAULT_REGION_CONTEXT.regionName,
    locale: DEFAULT_REGION_CONTEXT.locale,
    paymentMethods: [...DEFAULT_REGION_CONTEXT.paymentMethods],
    defaultPmId: DEFAULT_REGION_CONTEXT.defaultPmId,
    ip: DEFAULT_REGION_CONTEXT.ip,
    loaded: false
  },

  mutations: {
    SET_REGION_CONTEXT(state, context) {
      state.region = context.region
      state.regionName = context.regionName
      state.locale = context.locale
      state.paymentMethods = [...context.paymentMethods]
      state.defaultPmId = context.defaultPmId
      state.ip = context.ip
      state.loaded = true
    },
    RESET_REGION_CONTEXT(state) {
      state.region = DEFAULT_REGION_CONTEXT.region
      state.regionName = DEFAULT_REGION_CONTEXT.regionName
      state.locale = DEFAULT_REGION_CONTEXT.locale
      state.paymentMethods = [...DEFAULT_REGION_CONTEXT.paymentMethods]
      state.defaultPmId = DEFAULT_REGION_CONTEXT.defaultPmId
      state.ip = DEFAULT_REGION_CONTEXT.ip
      state.loaded = false
    }
  },

  actions: {
    async InitRegionContext({ commit, state }, forceRefresh = false) {
      // 每次都强制刷新，忽略 loaded 状态，确保每次访问都根据当前 IP 重新识别语言
      const geoContext = await resolveGeoIpContext(true)

      try {
        const res = await getRegionContext(buildRegionContextRequestOptions(geoContext))
        return hydrateRegionContext(commit, mergeAutoLocalePayload(res && res.data ? res.data : {}, geoContext))
      } catch (error) {
        return hydrateRegionContext(commit, buildFallbackRegionPayload(geoContext))
      }
    },

    ClearRegionContext({ commit }) {
      commit('RESET_REGION_CONTEXT')
    }
  }
}

function buildRegionContextRequestOptions(geoContext) {
  if (!geoContext || geoContext.region === REGION_UNKNOWN) {
    return {}
  }
  return {
    debugRegion: geoContext.region
  }
}

function mergeAutoLocalePayload(payload, geoContext) {
  const mergedPayload = {
    ...(payload || {})
  }
  if (geoContext && geoContext.resolved && geoContext.locale) {
    mergedPayload.locale = geoContext.locale
  }
  if (geoContext && geoContext.ip && !mergedPayload.ip) {
    mergedPayload.ip = geoContext.ip
  }
  return mergedPayload
}

function buildFallbackRegionPayload(geoContext) {
  // 完全基于 IP 识别，不再参考 localStorage 或当前 i18n.locale
  const fallbackPayload = {
    region: 'OTHER',
    regionName:"",
    paymentMethods: ['alipay_hk'],
    defaultPmId: 'alipay_hk',
    locale: geoContext && geoContext.resolved && geoContext.locale ? geoContext.locale : DEFAULT_LOCALE
  }
  if (geoContext && geoContext.ip) {
    fallbackPayload.ip = geoContext.ip
  }
  return fallbackPayload
}

function hydrateRegionContext(commit, payload) {
  const normalized = normalizeRegionContext(payload)
  const effectiveLocale = applyLocaleOverride(normalized.locale, normalized.region)
  const resolvedContext = {
    ...normalized,
    locale: effectiveLocale
  }
  commit('SET_REGION_CONTEXT', resolvedContext)
  return resolvedContext
}

function applyLocaleOverride(locale, region) {
  const normalizedRegion = String(region || '').toUpperCase()
  const resolvedLocale = normalizedRegion === 'HK'
    ? forceLocaleFromIP(locale)
    : resolvePreferredLocale(locale)
  if (i18n.locale !== resolvedLocale) {
    i18n.locale = resolvedLocale
  }
  return resolvedLocale
}

export default region
